import { dashboardState, projectDetailState } from '@obo-dashboard/states/dashboard.state';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { downloadsState } from './states/download.state';

export const DASHBOARD_STATES: Ng2StateDeclaration[] = [dashboardState, projectDetailState, downloadsState];
